import { timeZone } from '@brighterion/utils/date-timezone';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import { t } from 'i18next';
import * as Yup from 'yup';

export const scheduledDeploymentSchema = (locale: string | undefined) =>
    Yup.object().shape({
        comment: Yup.string().optional().max(150).trim().strict(),
        deployNow: Yup.boolean().default(true).required(),
        scheduledTime: Yup.date()
            .optional()
            .when('deployNow', {
                is: false,
                then: Yup.date()
                    .typeError(() => t('scheduledDeployment.form.invalid.date'))
                    .required(() => t('scheduledDeployment.form.required.date'))
                    .test({
                        name: 'currentDate',
                        message: () =>
                            t('scheduledDeployment.form.test.date', {
                                date: utcToZonedTime(new Date().getTime() + 5 * 60 * 1000, timeZone).toLocaleString(
                                    locale,
                                    {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    }
                                )
                            }),
                        test: (value) =>
                            new Date(value as Date).getTime() >=
                            utcToZonedTime(new Date().getTime() + 5 * 60 * 1000, timeZone).getTime()
                    })
            }),
        templateRepositoryId: Yup.number().positive().integer().required()
    });
